import type Graphic from "@arcgis/core/Graphic";

/**
 * The fields the light calculator writes on a light - see saveLightValues in LightCalculator.
 * The status field it also updates is deliberately absent: a replacement owns the status of
 * both objects, and copying it would undo the new object's Prosjektert.
 */
export const lightCalculationFields = [
    "lampe",
    "karakter",
    "periode",
    "lys_karakter",
    "lys_farge",
    "bakgrunnsbelysning",
    "lys_gjennomgang",
    "linse_orden",
    "lysstyrke_hvit",
    "rekkevidde_hvit",
    "lysstyrke_rod",
    "rekkevidde_rod",
    "lysstyrke_gronn",
    "rekkevidde_gronn",
    "lysstyrke_gul",
    "rekkevidde_gul",
] as const;

/**
 * Mirrors the light calculation from one light onto another, so that replacing a fyrlykt or
 * fyrstasjon with another one keeps the calculation instead of starting from blank presets.
 * A field the source never had is cleared rather than left behind, so the target ends up
 * showing the source's calculation and nothing else.
 */
export const copyLightCalculationValues = (source: Graphic, target: Graphic) => {
    for (const field of lightCalculationFields) {
        target.attributes[field] = source.attributes[field] ?? null;
    }
};
